// components/common/LoadingSpinner.jsx
import React from "react";
import { Loader2 } from "lucide-react";

const LoadingSpinner = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] p-4">
      <Loader2 className="h-8 w-8 animate-spin text-orange-500" />
      <p className="mt-2 text-sm text-gray-500">Cargando...</p>
    </div>
  );
};

export default LoadingSpinner;
